import { render, staticRenderFns } from "./CuserInfo.vue?vue&type=template&id=40b08178&scoped=true"
import script from "./CuserInfo.vue?vue&type=script&lang=js"
export * from "./CuserInfo.vue?vue&type=script&lang=js"
import style0 from "./CuserInfo.vue?vue&type=style&index=0&id=40b08178&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40b08178",
  null
  
)

export default component.exports